// extracted by mini-css-extract-plugin
module.exports = {"safeplace":"safeplace-IG2gu0C","form-label":"form-label-3tX0Uzk","input-wrapper":"input-wrapper-1Rf8ZhC"};